module.exports = "<div class=\"or-index-intro\">\n    <figure class=\"or-index-intro__img\"><img src=\"assets/images/intro/backstage-intro.png\" alt=\"\" /></figure>\n    <h2 class=\"or-index-intro__title\">Backstage yönetim ekranındasınız</h2>\n    <p class=\"or-index-intro__text\">Menüdeki linkleri kullanarak, uygulamanın fonksiyonlarına erişebilirsiniz.</p>    \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/index/index.component.html
// module id = ./src/app/routes/index/index.component.html
// module chunks = 9